module.exports = __webpack_public_path__ + "img/YourConcierge.ee1cc49a.jpg";